<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Rental Deposit Slip</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#depositSlip">Deposit Slip</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="depositSlip">
                            <form [formGroup]="depositSlipForm">
                                <div class="p-3">
                                    <label class="form-label fw-semibold">
                                        Select
                                    </label>

                                    <!-- Date Option -->
                                    <div class="form-check d-flex align-items-center mb-3">
                                        <input class="form-check-input me-2" type="radio" formControlName="optionType"
                                            value="date" id="dateOption">
                                        <label for="dateOption" class="form-check-label me-2 mb-0">Date</label>

                                        <ejs-datepicker id="datePicker" placeholder="Select a date"
                                            formControlName="date" style="max-width: 250px;">
                                        </ejs-datepicker>
                                    </div>

                                    <hr />

                                    <!-- Receipt Range Option -->
                                    <div class="form-check mb-2">
                                        <input class="form-check-input" type="radio" formControlName="optionType"
                                            value="range" id="rangeOption">
                                        <label for="rangeOption" class="form-check-label fw-semibold">Receipt
                                            Range</label>
                                    </div>

                                    <div class="mb-2">
                                        <div class="d-flex align-items-center gap-3">
                                            <div class="mb-3" style="max-width: 250px;">
                                                <label class="form-label">From Receipt #</label>
                                                <input type="number" class="form-control" formControlName="fromReceipt">
                                            </div>

                                            <div class="mb-3" style="max-width: 250px;">
                                                <label class="form-label">To Receipt #</label>
                                                <input type="number" class="form-control" formControlName="toReceipt">
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="d-flex gap-4" formGroupName="filters">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="cash"
                                                formControlName="cash">
                                            <label class="form-check-label" for="cash">Cash</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="checks"
                                                formControlName="checks">
                                            <label class="form-check-label" for="checks">Checks</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="card"
                                                formControlName="card">
                                            <label class="form-check-label" for="card">Credit/Debit Card</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="debit"
                                                formControlName="debit">
                                            <label class="form-check-label" for="debit">Debit</label>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-md-12 col-lg-8 text-start mt-2">
                                            <ejs-grid [dataSource]="depositSlipData" height="300" currencyCode="USD">
                                                <e-columns>
                                                    <e-column field="ReceiptID" headerText="Rpt#" width="100"
                                                        textAlign="Left"></e-column>
                                                    <e-column field="VendorId" headerText="Vendor ID" width="120"
                                                        textAlign="Left"></e-column>
                                                    <e-column field="VendorName" headerText="Vendor Name" width="180"
                                                        textAlign="Left"></e-column>
                                                    <e-column *ngIf="depositSlipForm.get('filters.cash')?.value"
                                                        field="Cash" headerText="Cash Amt" width="120" textAlign="Right"
                                                        type="number" format="$#,##0.00;($#,##0.00)">
                                                    </e-column>
                                                    <e-column *ngIf="depositSlipForm.get('filters.checks')?.value"
                                                        field="CheckNumber" headerText="Check #" width="150">
                                                    </e-column>
                                                    <e-column *ngIf="depositSlipForm.get('filters.checks')?.value"
                                                        field="Check" headerText="Check Amt" width="120"
                                                        textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)">
                                                    </e-column>
                                                    <e-column *ngIf="depositSlipForm.get('filters.card')?.value"
                                                        field="CreditCard" headerText="CC/DC Amt" width="120"
                                                        textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)">
                                                    </e-column>
                                                    <e-column *ngIf="depositSlipForm.get('filters.debit')?.value"
                                                        field="Debit" headerText="Debit Amt" width="120"
                                                        textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)">
                                                    </e-column>
                                                    <e-column field="GrandTotal" headerText="Grand Total" width="150"
                                                        textAlign="Right" type="number"
                                                        format="$#,##0.00;($#,##0.00)"></e-column>
                                                </e-columns>
                                            </ejs-grid>
                                        </div>
                                        <div class="col-md-12 col-lg-4 mt-2">
                                            <div class="card shadow-sm rounded-3">
                                                <div class="card-body">
                                                    <div class="row g-3">

                                                        <div class="col-md-6"
                                                            *ngIf="depositSlipForm.get('filters.cash')!.value">
                                                            <label class="form-label">Total Cash Amt</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="formatAccountingCurrency(totals.cash)"
                                                                readonly>
                                                        </div>

                                                        <div class="col-md-6"
                                                            *ngIf="depositSlipForm.get('filters.card')!.value">
                                                            <label class="form-label">Total CC / DC Amt</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="formatAccountingCurrency(totals.ccDc)"
                                                                readonly>
                                                        </div>

                                                        <div class="col-md-6"
                                                            *ngIf="depositSlipForm.get('filters.checks')!.value">
                                                            <label class="form-label">Total Check Amt</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="formatAccountingCurrency(totals.checks)"
                                                                readonly>
                                                        </div>

                                                        <div class="col-md-6"
                                                            *ngIf="depositSlipForm.get('filters.debit')!.value">
                                                            <label class="form-label">Total Debit Amt</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="formatAccountingCurrency(totals.debit)"
                                                                readonly>
                                                        </div>

                                                        <div class="col-12">
                                                            <label class="form-label fw-bold">Grand Total</label>
                                                            <input type="text" class="form-control fw-bold text-end"
                                                                [value]="formatAccountingCurrency(totals.grand)"
                                                                readonly>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 text-end my-2">
                                            <button class="btn btnAS me-1"
                                                [disabled]="!depositSlipData || depositSlipData.length === 0"
                                                (click)="onReportView()">Preview</button>
                                            <button class="btn btnAS me-1" hidden>Save</button>
                                            <button class="btn btn-orange"
                                                (click)="closeDepositSlipPage()">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
